var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(false)?_c('v-btn',{staticStyle:{"z-index":"99999"},attrs:{"bottom":"","color":"primary","dark":"","fab":"","fixed":"","right":"","x-small":""}},[_vm._v("\n    "+_vm._s(_vm.$vuetify.breakpoint.name)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }